// Angular
import { NgModule } from "@angular/core";

// Afidium
import { CommonModule } from "@angular/common";
import { SegmentListComponent } from "./segment-list.component";
import { SectorModule } from "libraries/sector/sector.module";
import { SegmentModule } from "libraries/segment/segment.module";
import { AllSegmentListComponent } from "./all-segment-list.component";
import { CarbonFootprintModule } from "libraries/component/carbon-footprint/carbon-footprint.module";
import { YucangooRatingModule } from "libraries/component/yucangoo-rating/yucangoo-rating.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PipesModule } from "libraries/pipes/pipes.module";
import { SortSegmentPipe } from "./sort-segment.pipe";

@NgModule({
    imports: [
        CommonModule,
        SectorModule,
        SegmentModule,
        CarbonFootprintModule,
        YucangooRatingModule,
        PermissionModule,
        FontAwesomeModule,
        PermissionModule,
        PipesModule,
    ],
    declarations: [
        SegmentListComponent,
        AllSegmentListComponent,
        SortSegmentPipe,
    ],
    exports: [
        SegmentListComponent,
        AllSegmentListComponent,
    ]
})
export class SegmentListModule {
}
